<div class="contentHeight container-fluid">
    <h1 class="text-center containerTitle">Planning - Gestion des rendez-vous</h1>
    <div class="row noMargin">
        <div class="col-12">
            <div class="text-right mb-1">
                <i aria-hidden="true" (click)="refresh()" class="fal fa-sync fa-lg p-2 pointer"></i>
                <span>Actualiser</span>
            </div>
        </div>
    </div>
    <div class="row mx-auto manageContent">
        <mat-table class="table lstdossier bg-white table-hover" [dataSource]="listRdvSource" matSort (matSortChange)="sortScale($event,'1')">

            <!--ID-->
            <ng-container matColumnDef="rdvID_G">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.rdvId'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res"> {{res.rdvID}}    </mat-cell>
            </ng-container>
            <!--Statut-->
            <ng-container matColumnDef="statusRDV_G">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.status'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">
                    <i aria-hidden="true" *ngIf="res.status == 1" class="fas fa-check fa-1-2x green" matTooltip="{{'planning.status1'|translate}}"></i>
                    <i aria-hidden="true" *ngIf="res.status == 2" class="fas fa-trash-alt fa-1-2x" matTooltip="{{'planning.status2'|translate}}"></i>
                </mat-cell>
            </ng-container>
            <!--Date rdv-->
            <ng-container matColumnDef="dateRDV_G">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.date'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.startDate | date:'dd/MM/yyyy HH:mm'}}</mat-cell>
            </ng-container>
            <!--Durée du rdv-->
            <ng-container matColumnDef="duration">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.duration'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.duration}}</mat-cell>
            </ng-container>
            <!--Hotliner-->
            <ng-container matColumnDef="hotliner">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Hotliner </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.firstnameHotliner}} {{res.nameHotliner}}</mat-cell>
            </ng-container>
            <!--Type d'intervention-->
            <ng-container matColumnDef="typeIntervention">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.type'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.typeIntervention}}</mat-cell>
            </ng-container>
            <!--CTC-->
            <ng-container matColumnDef="ctc_G">
                <mat-header-cell *matHeaderCellDef mat-sort-header> CTC </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.ctc_Firstname | titlecase}} {{res.ctc_Name | uppercase}}</mat-cell>
            </ng-container>
            <!--Téléphone CTC-->
            <ng-container matColumnDef="ctcPhone_G">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.ctcPhone'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.ctc_Phone}}</mat-cell>
            </ng-container>
            <!--Utilisateur-->
            <ng-container matColumnDef="user">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.site'|translate}} </mat-header-cell>
                <mat-cell *matCellDef="let res">{{res.user_SocialReason | uppercase}} - {{res.user_Firstname | titlecase}}  {{res.user_Name | uppercase}}</mat-cell>
            </ng-container>
            <!--Action-->
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                <mat-cell *matCellDef="let res">
                    <div *ngIf="res.canCancel" class="pointer mr-3" (click)="update(res.rdvID)">
                        <i aria-hidden="true" class="fal fa-edit fa-lg" matTooltip="Modifier"></i>
                    </div>
                    <div *ngIf="res.canCancel" class="pointer" (click)="cancel(res.rdvID)">
                        <i aria-hidden="true" class="fal fa-trash-alt fa-lg" matTooltip="Annuler"></i>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
    </div>
</div>

<!-- Modale Annulation de RDV -->
<div id="cancelModal" class="modal">
    <div class="modal-content" id="cancelModal-content">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('cancelModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h2 class="mb-2"> Annuler le RDV </h2>
            <hr />
        </div>
        <div class="row mt-3 mb-3" *ngIf="showCancelModal">
            <h3 class="col-12 text-center">{{currentRdv.startDate | date:'dd/MM/yyyy'}} - {{currentRdv.startDate |  date:'HH:mm'}} </h3>
            <span class="col-12 text-center">{{currentRdv.user_SocialReason | uppercase}} - {{currentRdv.user_Firstname | titlecase}}  {{currentRdv.user_Name | uppercase}}</span>
            <span class="col-12 text-center">{{currentRdv.label }}</span>
        </div>
        <div class="row" style="display: flex; justify-content: center;">
            <button class="btn btn-success col-1 mr-2" (click)="validCancel(true)">{{'planning.oui' | translate | titlecase}}</button>
            <button class="btn btn-danger col-1 ml-2" (click)="validCancel(false)">{{'planning.non' | translate | titlecase}}</button>
        </div>
    </div>
</div>

<!-- Modale Confirmation d'annulation de RDV -->
<div id="confirmCancelModal" class="modal">
    <div class="modal-content" id="confirmCancelModal-content">
        <span class="text-right mr-2 close pointer" (click)="closeModal('confirmCancelModal');">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <div>
                <h2 class="text-center">Le RDV a bien été annulé</h2>
                <div class="row">
                    <div class="text-center col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p> Le CTC va recevoir un mail de confirmation de l'annulation.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modale Modification de RDV -->
<div id="updateModal" class="modal">
    <div class="modal-content" id="updateModal-content">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('updateModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h2 class="mb-2"> Modifier le RDV </h2>
            <hr />
        </div>
        <div class="row mt-3 mb-3" *ngIf="showCancelModal">
            <h3 class="col-12 text-center">{{currentRdv.startDate | date:'dd/MM/yyyy'}} - {{currentRdv.startDate |  date:'HH:mm'}} </h3>
            <span class="col-12 text-center">{{currentRdv.user_SocialReason | uppercase}} - {{currentRdv.user_Firstname | titlecase}}  {{currentRdv.user_Name | uppercase}}</span>
            <span class="col-12 text-center">{{currentRdv.label }}</span>
            <span class="col-12 text-center">(Langue du CTC : {{languageCTC }})</span>
        </div>
        <div>
            <form [formGroup]="updateRdvForm" class="col-12 row ">
                <mat-form-field class="col-lg-4 col-sm-12">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-lg-4 col-sm-12">
                    <mat-label>Heure de début</mat-label>
                    <input matInput type="time" formControlName="start" required (blur)="changeEnd()">
                </mat-form-field>
                <mat-form-field class="col-lg-4 col-sm-12">
                    <mat-label>Heure de fin</mat-label>
                    <input matInput type="time" formControlName="end" required>
                </mat-form-field>
                <mat-form-field class="col-lg-12 col-sm-12">
                    <mat-label>Hotliner</mat-label>
                    <mat-select formControlName="hotliner" required>
                        <mat-option *ngFor="let hotliner of listHotliner"
                                    value="{{hotliner.loginHotliner}}"> {{hotliner.firstnameHotliner}} {{hotliner.nameHotliner}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
            <p id="text-error" *ngIf="invalidForm" class="invalid-form text-center ">L'heure de début doit être supérieure à l'heure de fin du RDV</p>
        </div>
        <div class="row" style="display: flex; justify-content: center;">
            <button class="btn btn-success col-2 mr-2" (click)="validUpdate(true)">Valider</button>
            <button class="btn btn-danger col-2 ml-2" (click)="validUpdate(false)">Annuler</button>
        </div>
    </div>
</div>

<!-- Modale Confirmation de modification de RDV (seulement date de début de RDV) -->
<div id="confirmUpdateStartDateModal" class="modal">
    <div class="modal-content" id="confirmUpdateStartDateModal-content">
        <span class="text-right mr-2 close pointer" (click)="closeModal('confirmUpdateStartDateModal');">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <div>
                <h2 class="text-center">Le RDV a bien été modifié</h2>
                <div class="row">
                    <div class="text-center col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p> Le CTC va recevoir un mail de confirmation de la modification du RDV.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modale Confirmation de modification de RDV (seulement date de fin de RDV) -->
<div id="confirmUpdateEndDateModal" class="modal">
    <div class="modal-content" id="confirmUpdateEndDateModal-content">
        <span class="text-right mr-2 close pointer" (click)="closeModal('confirmUpdateEndDateModal');">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <div>
                <h2 class="text-center">Le RDV a bien été modifié</h2>
                <div class="row">
                    <div class="text-center col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p> Le CTC ne sera pas prévenu du changement d'heure de fin du RDV.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modale Confirmation de modification de RDV (seulement hotliner) -->
<div id="confirmUpdateLoginModal" class="modal">
    <div class="modal-content" id="confirmUpdateLoginModal-content">
        <span class="text-right mr-2 close pointer" (click)="closeModal('confirmUpdateLoginModal');">
            <i aria-hidden="true" class=" fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <div>
                <h2 class="text-center">Le RDV a bien été modifié</h2>
                <div class="row">
                    <div class="text-center col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p> Le CTC ne sera pas prévenu du changement d'hotliner.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modale Loading -->
<div id="loadingModal" class="modal">
    <div class="modal-content" id="loadingContent">
        <div class="col-12 mt-5 mb-5 row justify-content-center loader-black">
            <mat-spinner diameter="70"> </mat-spinner>
        </div>
    </div>
</div>

<!-- Modale Erreur -->
<div id="errorModal" class="modal">
    <div class="modal-content" id="errorContent">
        <h1 class="text-center mt-3" [translate]="'planning.errorTitle'"></h1>
        <span class="text-center mt-3" [translate]="'planning.errorMsg'"></span>
        <button class="btn btn-secondary col-lg-2 col-md-2 col-sm-3 col-4"
                style="align-self:center;"
                (click)="closeError()" [translate]="'planning.closeError'"></button>
    </div>
</div>
